<template>
<div class="page page_income">
    <!-- 头部 -->
	<div class="top">
		<div class="txt">总收入：￥<span class="cash">{{totalPrice}}</span></div>
	</div>
	<!-- 日期选择 -->
	<!-- <div class="riqi_wrap">
		<div class="riqi" @click="show_starttime = true">{{ starttime ? starttime : '开始时间' }}</div>
		<div class="riqi" @click="show_endtime = true">{{ endtime ? endtime : '结束时间' }}</div>
	</div> -->
	<!-- 内容区 -->
	<div class="list">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
			<ul class="order" v-for="item in dataList" :key="item.id">
				<li class="item">
					<van-image class="thumb" fit="cover" :src="item.thumb ? ( $publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb ) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" round />
					<div class="item_back">
						<div class="name">{{item.nickname?item.nickname:(item.username?$publicData.formatPhone(item.username):'未注册')}}</div>
						<div style="display:flex;">
							<div class="item_r price_pay" >支付：{{'¥' +item.total_prices}}</div>
							<div class="item_r price" style="margin-left:0.4rem">收入：{{'¥' +item.prices}}</div>
						</div>
						
						<div class="bianhao">订单编号{{item.order_num}}</div>
						<div class="time">{{item.date}}</div>
					</div>
				</li>
			</ul>
		</van-list>
	</div>
	<!-- 开始时间 弹层 -->
	<van-popup v-model="show_starttime" position="bottom">
		<van-datetime-picker
		v-model="currentDateStart"
		type="date"
		:max-date="maxDate"
		@confirm="confirmDateStart" @cancel="show_starttime = false"
		/>
	</van-popup>
	<!-- 结束时间 弹层 -->
	<van-popup v-model="show_endtime" position="bottom">
		<van-datetime-picker
		v-model="currentDateEnd"
		type="date"
		:max-date="maxDate"
		 @confirm="confirmDateEnd" @cancel="show_endtime = false"
		/>
	</van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
			dataList: [],
			currentDateStart: new Date(), // 当天日期
			currentDateEnd: new Date(), // 当天日期
            finished: false,
            page: 1,
            size: 10,
            loading: false,
			refreshing: false,
			totalPrice: 0,
			starttime: null , //开始时间
			endtime: null, // 结束时间
			show_starttime: false, // 开始时间弹层
			show_endtime: false, // 结束时间弹层
			maxDate: new Date()
        };
    },
	mounted(){
		this.date = this.format(new Date())
	},
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "收入明细"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
				token: this.token,
                page: this.page,
                size: this.size
			}
			if(this.starttime != null){
				params.starttime = this.starttime
			}
			if(this.endtime != null){
				params.endtime = this.endtime
			}
            this.$api.park.moneylog(params).then(res => {
                if (res.code == 200) {
                    this.totalPrice = res.result.total_price
                    var list = res.result.list
                    if (this.page == 1) {
                        this.dataList = list
                    } else {
                        var old = this.dataList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.dataList = old
                    }
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
		},
		// 确认开始日期
		confirmDateStart(value){
			console.log(value)
			this.starttime = this.format(value)
			this.show_starttime = false
		},
		// 确认结束日期
		confirmDateEnd(value){
			this.endtime = this.format(value)
			this.show_endtime = false
		},
		// 日期格式  data是日期对象  返回格式2020-05-04
		format(data){
			var year = data.getFullYear();
			var month = data.getMonth() + 1
			var day = data.getDate()
			if(month.toString().length == 1){
				month = '0' + month
			}
			if(day.toString().length == 1){
				day = '0' + day
			}
			return year+'-'+month+'-'+day
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
